var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var BsDatepickerActions = (function () {
    function BsDatepickerActions() {
    }
    BsDatepickerActions_1 = BsDatepickerActions;
    BsDatepickerActions.prototype.calculate = function (viewDate) {
        return {
            type: BsDatepickerActions_1.CALCULATE,
            payload: viewDate
        };
    };
    BsDatepickerActions.prototype.format = function () {
        return {
            type: BsDatepickerActions_1.FORMAT
        };
    };
    BsDatepickerActions.prototype.flag = function () {
        return {
            type: BsDatepickerActions_1.FLAG
        };
    };
    BsDatepickerActions.prototype.select = function (date) {
        return {
            type: BsDatepickerActions_1.SELECT,
            payload: date
        };
    };
    BsDatepickerActions.prototype.navigateStep = function (step) {
        return {
            type: BsDatepickerActions_1.STEP_NAVIGATION,
            payload: step
        };
    };
    BsDatepickerActions.prototype.renderOptions = function (options) {
        return {
            type: BsDatepickerActions_1.RENDER_OPTIONS,
            payload: options
        };
    };
    // date range picker
    BsDatepickerActions.prototype.selectRange = function (value) {
        return {
            type: BsDatepickerActions_1.SELECT_RANGE,
            payload: value
        };
    };
    BsDatepickerActions.prototype.hover = function (event) {
        return {
            type: BsDatepickerActions_1.HOVER,
            payload: event.isHovered ? event.day.date : null
        };
    };
    BsDatepickerActions.CALCULATE = '[datepicker] calculate dates matrix';
    BsDatepickerActions.FORMAT = '[datepicker] format datepicker values';
    BsDatepickerActions.FLAG = '[datepicker] set flags';
    BsDatepickerActions.SELECT = '[datepicker] select date';
    BsDatepickerActions.STEP_NAVIGATION = '[datepicker] shift view date';
    BsDatepickerActions.RENDER_OPTIONS = '[datepicker] update render options';
    BsDatepickerActions.HOVER = '[datepicker] hover date';
    BsDatepickerActions.SELECT_RANGE = '[daterangepicker] select dates range';
    BsDatepickerActions = BsDatepickerActions_1 = __decorate([
        Injectable()
    ], BsDatepickerActions);
    return BsDatepickerActions;
    var BsDatepickerActions_1;
}());
export { BsDatepickerActions };
//# sourceMappingURL=bs-datepicker.actions.js.map


//////////////////
// WEBPACK FOOTER
// /revet-web/node_modules/ngx-bootstrap/datepicker/reducer/bs-datepicker.actions.js
// module id = ../../../../ngx-bootstrap/datepicker/reducer/bs-datepicker.actions.js
// module chunks = vendor